<template>
<form ref="form" name="form_auth" method="post" :action="popupUrl" target="_self">
    <!-- 필수 항목 · tc 는 변경불가 (규격 샘플 popup2.html) -->
    <input type="hidden" name="tc" value="kcb.oknm.online.main.popup.cmd.P941_CertChoiceCmd" />
    <input type="hidden" name="idcf_mbr_com_cd" :value="siteCode" />
    <input type="hidden" name="svc_tkn" :value="svcTkn" />
</form>
</template>

<script>
// 새 창 안에서 열린다. 거래요청 API 로 svc_tkn 을 받아 이 창 자체를 KCB 표준창으로 넘긴다.
// 인증이 끝나면 KCB 가 return_url(/api/kcb/return) 로 돌려보내고, 서버가 /plugins/kcb/cert/response 로 보낸다.
export default {
    data() {
        return {
            popupUrl: "",
            siteCode: "",
            svcTkn: "",
        }
    },
    mounted() {
        this.auth();
    },
    methods: {
        async auth() {
            try {
                var { popupUrl, siteCode, svcTkn } = await this.$http.post(`/api/plugins/kcb/cert/request`, null, {
                    headers: {
                        authorization: this.accessToken ? `Bearer ${this.accessToken}` : ''
                    }
                }).then(res => res.data);

                this.popupUrl = popupUrl;
                this.siteCode = siteCode;
                this.svcTkn = svcTkn;

                this.$nextTick(() => this.$refs.form.submit());
            } catch (error) {
                alert(error?.response?.data?.message || error?.message || "본인확인 요청에 실패하였습니다");
                window.close();
            }
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        }
    }
};
</script>
